export class TrafficLightRange {
  range: boolean;
  startF: number;
  endF: number;

  constructor() {
    this.range = false;
    this.startF = 0.0;
    this.endF = 0.0;
  }
}
